const tvShowEmojis = new Map([  
  ['Game of Thrones', '🐉⚔️👑'],
  ['Friends', '👥🍕🎉'],
  ['Breaking Bad', '💊💣🧪'],
  ['Simpsons', '🍩📺🎉'],
  ['Stranger Things', '👦🚲🔦'],
  ['Office', '👔🖨️😂'],
  ['Black Mirror', '🖥️👁️🌐'],
  ['Sherlock', '🔎🕵️‍♂️🎩'],
  ['Mandalorian', '🌌👶🪐'],
]);

export default tvShowEmojis;
